import { images, importAllImages } from '../utils/importImages';
import house from '../icons/house2-black.svg';
import { NavLink } from "react-router-dom";



const FilmPage = ({title, bread, youtube}) => {

  return (

    <>
      {/* need both header tags for footer to sit at bottom */}
      <header></header>
      <article>
        <span id="header">&nbsp;</span>
        <div class="video">
          <table class="tableheader">
            <colgroup>
              <col width="auto" />
              <col width="80" />
            </colgroup>
            <tr>
              <td  style={{padding: "0px", paddingLeft: "12px"}}>
                <h2 style={{marginLeft: "0px"}}>JIN LU - {title}</h2>
              </td>
              <td style={{textAlign: "right"}}>
                <span id="spanhome"><NavLink id="ahome" to="/"><img src={house} style={{marginRight: "24px" }}  /></NavLink></span>
              </td>
            </tr>
          </table>
          {/* breadcrumbs */}
          <ul class="breadcrumbs" style={{marginLeft: "12px"}}>
            <li><NavLink to="/" style={{marginRight: "4px"}}>Jin Lu Actor - Home</NavLink></li>
            <li>{bread}</li>
          </ul>

          <div class="topband" style={{height: "10px", background: "black"}}></div>
          <div class="youtube">
            <iframe src={youtube}
              title={title} frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
              allowfullscreen
              webkitallowfullscreen
              mozallowfullscreen
              ></iframe>
          </div>
          <div class="bottomband" style={{height: "10px", background: "black"}}></div>

        </div>
      </article>
      <footer>
        <span id="footer">&nbsp;</span>
      </footer>
    </>

  );
};

export default FilmPage;
